export default __webpack_public_path__ + "static/ak-cached/24h/media/CloseButtonHover.fdc9dc6d.svg";